import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';
import { newsTranslations } from '../data/translations/newsTranslations';

export default function NewsArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = newsTranslations[language].news;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const post = t.posts.find((p) => String(p.id) === String(id));

  if (!post || !post.article) {
    return (
      <div className="flex flex-col min-h-screen bg-background text-on-surface">
        <Navbar />
        <main className="flex-grow flex items-center justify-center pt-24">
          <p className="text-muted font-body">Artículo no encontrado.</p>
        </main>
        <Footer />
      </div>
    );
  }

  const { article } = post;

  return (
    <div className="flex flex-col min-h-screen bg-background text-on-surface font-body">
      <Navbar />

      <main className="flex-grow pt-28 pb-24 px-4 sm:px-8">
        <div className="max-w-3xl mx-auto">

          {/* Back link */}
          <button
            onClick={() => navigate('/#news')}
            className="flex items-center gap-2 text-muted hover:text-secondary text-xs font-black uppercase tracking-widest transition-colors mb-12 group"
          >
            <span className="material-symbols-outlined text-sm group-hover:-translate-x-1 transition-transform duration-200">west</span>
            {language === 'es' ? 'Volver a Noticias' : 'Back to News'}
          </button>

          {/* Hero image or gradient banner */}
          <div className="w-full h-72 rounded-2xl overflow-hidden mb-10">
            {post.image ? (
              <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-secondary/30 via-primary/10 to-background" />
            )}
          </div>

          {/* Meta */}
          <div className="flex items-center gap-4 mb-5">
            <span className="px-3 py-1 bg-secondary/10 text-secondary font-black text-[10px] uppercase tracking-[0.15em] rounded-full">
              {post.source}
            </span>
            <span className="text-muted font-mono text-xs">{post.date}</span>
          </div>

          {/* Title */}
          <h1 className="font-headline text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary leading-tight tracking-tight mb-4">
            {post.title}
          </h1>

          {/* Dateline */}
          <p className="text-muted text-sm font-medium mb-12 border-b border-border pb-8">
            {article.dateline}
          </p>

          {/* Article body */}
          <div className="space-y-10">
            {article.sections.map((section, i) => (
              <div key={i}>
                {section.heading && (
                  <h2 className="font-headline text-xl md:text-2xl font-extrabold text-primary mb-4 tracking-tight">
                    {section.heading}
                  </h2>
                )}
                <div className="space-y-5">
                  {section.body.map((para, j) => (
                    <p key={j} className="text-on-surface opacity-80 text-base md:text-lg leading-relaxed">
                      {para}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Bottom image */}
          {post.image2 && (
            <div className="mt-12 w-full rounded-2xl overflow-hidden">
              <img src={post.image2} alt="" className="w-full object-cover" />
            </div>
          )}

          {/* Footer CTA */}
          <div className="mt-16 pt-10 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <p className="text-muted text-sm">
              {language === 'es'
                ? `Por ${post.author} · ${post.date}`
                : `By ${post.author} · ${post.date}`}
            </p>
            <button
              onClick={() => navigate('/#news')}
              className="flex items-center gap-2 text-secondary font-black text-xs uppercase tracking-widest hover:text-primary transition-colors group"
            >
              <span className="material-symbols-outlined text-sm group-hover:-translate-x-1 transition-transform duration-200">west</span>
              {language === 'es' ? 'Volver a Noticias' : 'Back to News'}
            </button>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
